import React from 'react'
import { SideSlider } from '../SideSlider/SideSlider'
import Header from '../Header/Header'
import { layoutStyles as styles } from './authenticationLayout.tailwind'
import { commonStyles } from './authenticationLayoutCommonStyling.tailwind'
import { APP_NAME } from '../../lib/constants/globalConstant'

// This is Higher Order Component (Authentication Layout)

// options-props-type
// {
//     showButton: boolean,
//     navUrl: string,
//     buttonName: string
//     heading: string,
//     subHeading: string
// }

const AuthenticationLayout = ({ children, options }) => {
    const { showButton, navUrl, buttonName, heading, subHeading = `Welcome To ${APP_NAME}`, isCentered = true, showMiddleImage, middleImage } = options
    // destructuring options
    
    return (
        <main className={styles.container}>
          {/* SideSlider only shown on medium screens and larger screens */}
          <section className={styles.slider_wrpr}>
            <SideSlider />
          </section>
    
          {/* Header centered on small screens, aligned to the left on larger screens */}
          <section className={styles.page_section_wrpr}>
            <Header showButton={showButton} buttonName={buttonName} navUrl={navUrl} showMiddleImage={showMiddleImage} middleImage={middleImage} />
            
            {/* Common Container */}
            <div className={`${commonStyles.container} ${!isCentered ? '!justify-start pt-[unset] md:pt-10' : ''}`}>
              <div className={commonStyles.wrapper}>
                {/* Heading and Sub-Heading Wrapper */}
                <div className={commonStyles.heading_wrpr}>
                  {/* Login text */}
                  <h1 className={commonStyles.heading}>{heading}</h1>
                  {/* Subheading */}
                  <p className={commonStyles.sub_heading}>{subHeading}</p>
                </div>

                {/* Child Component */}
                {children}
              </div>
            </div>
          </section>
        </main>
    )
}

export default AuthenticationLayout